import WarningAlt16 from '@carbon/icons-react/es/warning--alt/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconShell } from 'components/atoms/icon-shell';
import styles from './at-risk.module.css';

export const AtRisk: FC = () => (
  <div data-cy="task.at_risk.banner" className={styles.item}>
    <IconShell icon={<WarningAlt16 className={styles.icon} />} />
    <div>
      <FormattedMessage id="task.at_risk" />
    </div>
  </div>
);
